import { Routes } from "@angular/router";
import { HomeComponent } from "./modules/home/pages/home/home.component";
import { NotfoundComponent } from "./modules/home/pages/notfound/notfound.component";
import { ReportedLessonsListComponent } from "./modules/home/pages/reportedlessons-list/reportedlessons-list.component";
import { MsalGuard } from "@azure/msal-angular";
import { LessonRoutingGuard } from "./core/services/lesson-routing-guard.service";

const routes: Routes = [
  { path: "", component: HomeComponent, canActivate: [MsalGuard] },
  { path: "home", component: HomeComponent, canActivate: [MsalGuard] },
  {
    path: "report",
    loadComponent: () =>
      import("./modules/home/pages/report/report.component").then(
        (m) => m.ReportPageComponent
      ),
    canActivate: [MsalGuard],
  },
  {
    path: "createNewLesson",
    loadChildren: () =>
      import(
        "./modules/home/pages/create-edit-publish-lesson/create-edit-publish-lesson.routes"
      ).then((m) => m.CREATE_EDIT_PUBLISH_LESSON_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: "editLesson",
    loadChildren: () =>
      import(
        "./modules/home/pages/create-edit-publish-lesson/create-edit-publish-lesson.routes"
      ).then((m) => m.CREATE_EDIT_PUBLISH_LESSON_ROUTES),
    canActivate: [MsalGuard, LessonRoutingGuard],
  },
  {
    path: "viewLesson",
    loadChildren: () =>
      import(
        "./modules/home/pages/create-edit-publish-lesson/create-edit-publish-lesson.routes"
      ).then((m) => m.CREATE_EDIT_PUBLISH_LESSON_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: "lessons",
    loadComponent: () =>
      import("./modules/home/pages/lessons-list/lessons-list.component").then(
        (m) => m.LessonsListPageComponent
      ),
    canActivate: [MsalGuard],
  },
  {
    path: "reportedLessons",
    component: ReportedLessonsListComponent,
    canActivate: [MsalGuard],
  },
  {
    path: "projectLookbackView",
    loadChildren: () =>
      import(
        "./modules/home/pages/project-lookback/project-lookback.routes"
      ).then((m) => m.PROJECT_LOOKBACK_ROUTES),
    canActivate: [MsalGuard],
  },
  {
    path: "coordinatorDashboard",
    loadComponent: () =>
      import(
        "./modules/home/pages/coordinator-dashboard/dashboard-landing/dashboard-landing.component"
      ).then((m) => m.DashboardLandingComponent),
    canActivate: [MsalGuard],
  },
  {
    path: "adminPortal",
    loadComponent: () =>
      import(
        "./modules/home/pages/admin-portal/admin-landing/admin-landing.component"
      ).then((m) => m.AdminLandingComponent),
    canActivate: [MsalGuard],
  },
  { path: "**", component: NotfoundComponent, canActivate: [MsalGuard] },
];

export { routes };
